var _g, _g2, _g3, _g4, _g5, _g6, _path, _text, _g7, _g8, _g9, _g10, _text2, _g11, _g12, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRollOfDumpsterTruckWithTrailer2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1 0 773 242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    transform: "translate(75.004 -35.062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.096 185.2v-24.4",
    "data-name": "Line 54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.997 185.2h78.091v4.7c.007 3.31 1.832 5.99 4.085 6h5.106",
    "data-name": "Path 76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 185.2h22",
    "data-name": "Line 55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.727 197.378h16.812c2.971 0 5.379-3.009 5.379-6.721v-45.741a14.97 14.97 0 0 0-1.445-6.52l-25.05-53.164a5.357 5.357 0 0 0-4.657-3.31h-41.348c-2.971 0-5.379 3.009-5.379 6.721v78.944H318.554c-2.128 0-3.854 2.156-3.854 4.815v8.12c0 2.659 1.725 4.815 3.854 4.815H339",
    "data-name": "Path 77"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 24",
    transform: "translate(530.72 171.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 25",
    transform: "translate(400.4 171.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 26",
    transform: "translate(338 171.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 27",
    transform: "translate(540.82 181.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 28",
    transform: "translate(410.5 181.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 29",
    transform: "translate(348.1 181.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.902 112.1h-29.627c-3.282 0-5.943 3-5.943 6.7v13.5c0 3.7 2.661 6.7 5.943 6.7h43.643",
    "data-name": "Path 78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.282 149.1h-20.071a9.836 9.836 0 0 0-6.849 2.7l-15.8 15.7",
    "data-name": "Path 80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 198.4h20",
    "data-name": "Line 59"
  })), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M549.713 110.942V58.009H378.137v52.933l12.681 12.51h146.364Z",
    "data-name": "Path 82"
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    "data-name": "Group 3",
    transform: "rotate(-20 -7237.27 13309.073)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.9,
    cy: 5.9,
    r: 5.9,
    strokeWidth: 5.027,
    "data-name": "Ellipse 23",
    transform: "translate(4629.886 3532.353)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.027,
    d: "m4632.244 3543.829-8.337 7.122a3.528 3.528 0 0 1-4.9-.9 3.528 3.528 0 0 1 .9-4.9l10.4-8.417",
    "data-name": "Path 79"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 3.351,
    d: "M4608.186 3554.851c-2 6.8 7.2 7.6 6.1 1.6-.8-4.5 4.1-6.3 4.1-6.3",
    "data-name": "Path 83"
  })), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M585.998 113.53v-11.287a3.213 3.213 0 0 0-3.207-3.306l-6.58.025a3.08 3.08 0 0 0-3.116 3.148v10.869",
    "data-name": "Path 81"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 5.027,
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M583.106 99.195v-29",
    "data-name": "Line 56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.751 98.556V73.812",
    "data-name": "Line 57"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    "data-name": "Group 11",
    transform: "translate(-4009.396 -3522.305)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 25",
    transform: "translate(4109.3 3658.843)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 26",
    transform: "translate(4046.9 3658.843)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 28",
    transform: "translate(4119.4 3668.943)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 29",
    transform: "translate(4057 3668.943)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4089.9 3685.642h20m-20 0h20",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M4090.5 3669.943h22",
    "data-name": "Line 55"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 25",
    transform: "translate(4305.4 3658.843)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 26",
    transform: "translate(4243 3658.843)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 28",
    transform: "translate(4315.5 3668.943)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 29",
    transform: "translate(4253.1 3668.943)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4286 3685.642h20",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 25",
    transform: "translate(4305.4 3658.843)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 26",
    transform: "translate(4243 3658.843)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 28",
    transform: "translate(4315.5 3668.943)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 29",
    transform: "translate(4253.1 3668.943)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4286 3685.642h20",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4285 3669.943h22",
    "data-name": "Line 55"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M4152.054 3669.943H4243",
    "data-name": "Path 2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M4347.064 3669.943h19.608v-15.972h-332.741",
    "data-name": "Path 3"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4089.9 3685.642h20m-20 0h20",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M4090.5 3669.943h22",
    "data-name": "Line 55"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4089.9 3685.642h20m-20 0h20",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4088.9 3669.943h22",
    "data-name": "Line 55"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M4033.931 3653.971v15.673h13.992",
    "data-name": "Path 4"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M4197.527 3633.247v-52.933h-160.146v52.933l11.837 12.51h136.613Zm169.146 0v-52.933h-160.146v52.933l11.837 12.51h136.613Z",
    "data-name": "Path 82"
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.027,
    d: "m4359.544 3678.231 23.885-9.639a3.528 3.528 0 0 1 4.296 2.522 3.528 3.528 0 0 1-2.521 4.296l-25.867 10.408",
    "data-name": "Path 79"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 3.351,
    d: "M4398.764 3670.023c4.205-5.706-4.166-9.604-5.185-3.59-.787 4.503-6.007 4.518-6.007 4.518",
    "data-name": "Path 83"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M4348.899 3685.642h10.8v-15",
    "data-name": "Path 5"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4152.3 3685.642h91.2",
    "data-name": "Line 59"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M32.598 201.749h629.591",
    "data-name": "Line 60"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m35.016 206.249-14.508-4.5 14.508-4.5Z",
    "data-name": "Path 88"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m659.585 206.249 14.508-4.5-14.508-4.5Z",
    "data-name": "Path 89"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4.5 6.5v165.8",
    "data-name": "Line 62"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "M0 7.8 4.5 0 9 7.8Z",
    "data-name": "Path 92"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m0 171 4.5 7.8L9 171Z",
    "data-name": "Path 93"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m676.767 177.86 21.2-34.863",
    "data-name": "Line 63"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m681.354 179.058-7.915 4.393.187-8.972Z",
    "data-name": "Path 94"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m701.131 146.474.187-8.972-7.84 4.273Z",
    "data-name": "Path 95"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-840.332 -6333.572)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M347.529 201.921a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051h-13.828a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "L,L m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(319.229 232.167)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "L,L m"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(-455.607 -6374.741)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.814 6547.788a2 2 0 0 1 .802 2.204l-5.854 20.574a2 2 0 0 1-3.806.132l-11.848-32.568a2 2 0 0 1 3-2.344Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "W,W m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(700.393 192.259)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "W,W m")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 124",
    transform: "translate(-1133.601 -6535.797)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 33,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.798 6556.71a2 2 0 0 1 2.204-.8l20.574 5.853a2 2 0 0 1 .132 3.806l-32.568 11.848a2 2 0 0 1-2.344-3Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "H,H m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(26.066 27.966)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "H,H m")))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M378.112 190.556h285.079",
    "data-name": "Line 61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m379.936 195.056-10.943-4.5 10.943-4.5Z",
    "data-name": "Path 90"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m661.367 195.056 10.8-4.5-10.8-4.5Z",
    "data-name": "Path 91"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-660.139 -6337.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M527.686 191.919a2 2 0 0 1 1.735-1.329 2 2 0 0 1 1.736 1.329l7.057 15.724a3.739 3.739 0 0 1 .046 2.844 2.046 2.046 0 0 1-1.782 1.442h-14.114a2.046 2.046 0 0 1-1.782-1.442 3.739 3.739 0 0 1 .046-2.844Z",
    "data-name": "Polygon 6"
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    "data-name": "B,B m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(502.422 228.648)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "B,B m"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M29.627 190.556h319.535",
    "data-name": "Line 61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m31.451 195.056-10.943-4.5 10.943-4.5Z",
    "data-name": "Path 90"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m347.338 195.056 10.8-4.5-10.8-4.5Z",
    "data-name": "Path 91"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-1008.624 -6337.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M179.201 191.919a2 2 0 0 1 1.735-1.329 2 2 0 0 1 1.736 1.329l7.057 15.724a3.739 3.739 0 0 1 .046 2.844 2.046 2.046 0 0 1-1.782 1.442h-14.114a2.046 2.046 0 0 1-1.782-1.442 3.739 3.739 0 0 1 .046-2.844Z",
    "data-name": "Polygon 6"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    "data-name": "S,S m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(153.937 228.648)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "S,S m"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollOfDumpsterTruckWithTrailer2);
export default __webpack_public_path__ + "static/media/RollOfDumpsterTruckWithTrailer2.3110c7c6007e67877c79ea39956d6dae.svg";
export { ForwardRef as ReactComponent };